import Head from 'next/head'

import { SParent, STechSupLink, STextError, STitle } from './style/error.styled'

export const Error = () => (
  <SParent>
    <Head>
      <title>Ошибка :(</title>
    </Head>
    <STitle>Ошибка</STitle>
    <STextError>
      Случилась какая-то ошибка. Попробуйте повторить запрос или обратитесь в
      службу поддержки по адресу:
    </STextError>
    <STechSupLink href="https://sd.72to.ru" target="_blank">
      sd.72to.ru
    </STechSupLink>
  </SParent>
)
